module.exports = __webpack_public_path__ + "img/banner_signup.7f2b5399.png";